import React, { MouseEventHandler } from 'react';
import { Text, Box, BoxProps, Anchor } from 'grommet';
import { Card, CardImg, CardBody, CardFooter } from 'reactstrap';
import { VideoInfo } from '../models/VideoInfo'
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string'

interface IInfoCardProps extends BoxProps {
    data: VideoInfo;
    onClick?: MouseEventHandler<HTMLDivElement>;
};

// type InfoCardProps = IInfoCardProps
//     & RouteComponentProps;

export default class InfoCard extends React.PureComponent<IInfoCardProps> {
    render() {
        let video = this.props.data;
        let audioLanguages = video.audioLanguages.map((audioLanguage: any, ndx:number) => {
            return <Text size='xsmall' key={`al-${ndx}`}>{audioLanguage}</Text>;
        });
        let location = window.location;
        let rootUrl = location.pathname;
        let url = video.href.endsWith('/') ? video.href : `${video.href}/`;
        let query = queryString.parse(location.search)

        rootUrl = rootUrl.endsWith('/') ? rootUrl.substring(0, rootUrl.lastIndexOf('/')) : rootUrl;
        rootUrl = rootUrl.endsWith('/us/en') ? rootUrl.substring(0, rootUrl.indexOf('/us/en')) : rootUrl;
        url = url.startsWith(rootUrl) ? url : `${rootUrl}${url}`
        url = query.lang !== undefined ? `${url}?lang=${query.lang}` : url;

        return <Box fill {...this.props}>
            <Card style={{ maxWidth: "160px", height: "100%" }} >
                <CardImg top width="100%" style={{ maxHeight: "80px", minHeight: "80px", backgroundColor: "black" }} src={video.thumbnailImage} alt="" />
                <div className="vcard-duration">
                    <span className="timeCode">{video?.length}</span>
                </div>
                {video?.isPodcast && <div className="vcard-podcast">
                    <span className="podcast-label">Podcast</span>
                </div>}
                <CardBody className="p-1">
                    <Anchor size="xsmall" color="brand" href={url}>{video.name}</Anchor>
                </CardBody>
                <CardFooter className="p-2">
                    <Box>
                        {audioLanguages}
                        <Text size='xsmall'>{video.uploadDate}</Text>
                        <Text size='xsmall'>{video.views} View{video.views !== 1 ? 's' : ''}</Text>
                        {video.hasCaptions && video.hasAlternateAudio &&
                            <Text size='xsmall' weight="bold">Captions | Audio tracks</Text>
                        }
                        {!video.hasCaptions && video.hasAlternateAudio &&
                            <Text size='xsmall' weight="bold">Audio tracks</Text>
                        }
                        {video.hasCaptions && !video.hasAlternateAudio &&
                            <Text size='xsmall' weight="bold">Captions</Text>
                        }
                    </Box>
                </CardFooter>
            </Card>
        </Box>;
    }
}